import { render, staticRenderFns } from "./ChangeOrgUser.vue?vue&type=template&id=51793c64&scoped=true";
import script from "./ChangeOrgUser.vue?vue&type=script&lang=js";
export * from "./ChangeOrgUser.vue?vue&type=script&lang=js";
import style0 from "./ChangeOrgUser.vue?vue&type=style&index=0&id=51793c64&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "51793c64", null);
export default component.exports;